import React, { useEffect, useState } from "react";
import { FormGroup, Input } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import { EditorState } from "draft-js";
import ModalFrame from "../../../../../../../../../toolkit/modalFrame";
import PrimaryButton from "../../../../../../../../../toolkit/primaryButton";
import styles from "../../styles.scss";
import {
  applyLinkToEditorState,
  deriveLinkModalFields,
  isAcceptableLinkUrl,
  removeLinkFromEditorState,
} from "../rteLinkUtils";

interface RteLinkModalProps {
  isOpen: boolean;
  toggle: () => void;
  editorState: EditorState;
  entityKey: string | null;
  onComplete: (editorState: EditorState) => void;
}

const RteLinkModal = ({
  isOpen,
  toggle,
  editorState,
  entityKey,
  onComplete,
}: RteLinkModalProps) => {
  const [preview, setPreview] = useState("");
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    const fields = deriveLinkModalFields(editorState, entityKey);
    setPreview(fields.preview);
    setUrl(fields.url);
  }, [isOpen, editorState, entityKey]);

  const disableSave = preview.length === 0 || !isAcceptableLinkUrl(url);

  const onSubmit = () => {
    onComplete(applyLinkToEditorState(editorState, preview, url, entityKey));
    toggle();
  };

  const onRemove = () => {
    if (!entityKey) return;
    onComplete(removeLinkFromEditorState(editorState, entityKey));
    toggle();
  };

  return (
    <ModalFrame title="Insert link" size="md" isOpen={isOpen} toggle={toggle}>
      <FormGroup>
        <label className={styles.rteLinkFieldLabel}>
          Link text
          <Input
            className={styles.input}
            type="text"
            id="rte-link-preview"
            value={preview}
            placeholder="Example"
            onChange={(event) => setPreview(event.target.value)}
          />
        </label>
        <label className={styles.rteLinkFieldLabel}>
          Link URL
          <Input
            className={styles.input}
            type="text"
            id="rte-link-url"
            value={url}
            placeholder="www.example.com or https://www.example.com"
            onChange={(event) => setUrl(event.target.value)}
          />
        </label>
      </FormGroup>
      <div className={styles.rteLinkModalActions}>
        {entityKey && (
          <button type="button" className={styles.formCancelText} onClick={onRemove}>
            Remove link
          </button>
        )}
        <PrimaryButton
          className={styles.rteLinkSaveButton}
          onClick={onSubmit}
          disabled={disableSave}
        >
          Save
        </PrimaryButton>
      </div>
    </ModalFrame>
  );
};

export default withStyles(styles)(RteLinkModal);
